import { forwardRef, useImperativeHandle } from 'react';

function DividerItem(props, ref) {
    useImperativeHandle(ref, () => ({
        get props() { return {}; }
    }));

    return (
        null
    );
}

export default forwardRef(DividerItem);